<template>
  <div class="InfoUserTraining">
    <div class="d-flex-between-center">
      <p class="f-16 f-c-midgrey f-Overpass">{{ header }}</p>
      <p class="f-16 f-c-black f-Overpass">{{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoUserTraining",
  props: {
    header: "",
    value: "",
  },
};
</script>
